/**
 * Estilos do `<Logo />` por origem da imagem.
 *
 * Os filtros **não** usam o variant Tailwind `dark:` do projeto: ele casa com qualquer
 * ancestral `data-theme="dark"` (ex.: header no hero). O branco no escuro e o invert do
 * fallback seguem só `html[data-theme='light'|'dark']` em `globals.css` (`.logo-brand-mark`,
 * `.logo-fallback-mark`).
 */
/**
 * Largura/altura vêm do estilo inline (`widthPx` + `height: auto`) e de `max-w-full`.
 * Evita caixas fixas (ex. 150×34 px) que cortavam logos PNG mais largos ou altos.
 */
export const logoLayoutClass = 'block h-auto max-h-14 w-auto max-w-full object-contain object-left' as const

/** Logo vetorial (SVG) no cabeçalho/rodapé — filtro branco só em `html[data-theme='dark']`. */
export const logoBrandMarkClass = 'logo-brand-mark' as const

/** PNG/WebP/etc. do CMS — sem filtro (o filtro de vetor destrói marcas coloridas em raster). */
export const logoBrandMarkRasterClass = 'logo-brand-mark-raster' as const

/** SVG Payload CDN — invert só em `html[data-theme='light']`. */
export const logoFallbackMarkClass = 'logo-fallback-mark' as const

export function logoMarkClassName(hasCustomBrandMark: boolean, srcIsVector: boolean): string {
  if (!hasCustomBrandMark) return logoFallbackMarkClass
  return srcIsVector ? logoBrandMarkClass : logoBrandMarkRasterClass
}
